/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

const APP_PLATFORM = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
    WEB: 'web',
};

/**
 * sectionId to identify pdp header
 * or app tile footer cta clicks
 */
const ACTION_BAR_SECTION = 'action-bar';

const ACTION_VARIANT_TYPE = {
    PRIMARY: 'primary',
    DROPDOWN: 'dropDown',
};

const LABEL_VARIANT_TYPE = {
    UPTO_DATE: 'uptoDate',
};

const ICON_VARIANT_TYPE = {
    CHECKMARK_CIRCLE: 'CheckmarkCircle',
};

const PLATFORM_FILTERS = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
    WEB: 'web',
};

const DESKTOP_APP_FILTERS = {
    INSTALLED: 'installed',
    NOT_INSTALLED: 'not-installed',
    SUBSCRIBED: 'subscribed',
    TRIAL_AVAILABLE: 'trial-available',
    TRIAL_ACTIVE: 'trial-active',
    TRIAL_EXPIRED: 'trial-expired',
    COMPATIBLE: 'compatible',
};

const UPDATES_APP_FILTERS = {
    UPDATED_RECENTLY: 'recent-updates',
    NEW_VERSION_UPDATE: 'new-version-update',
    PATCH_UPDATE: 'patch-update',
    NEW_UPDATES: 'new-updates',
};

const ACTION_ID = {
    LEARN_MORE: 'learn-more',
    LEARN_MORE_PDP: 'learn-more-pdp',
    START_TRIAL: 'startTrial',
    DISCOVER: 'discover',
    OPEN: 'open',
    BUY_NOW: 'buy-now',
    BUY: 'buy',
    LIST_OTHER_VERSIONS: 'listOtherVersions',
    UNINSTALL: 'uninstall',
    UPDATE: 'update',
    RETRY: 'retry',
    INSTALL: 'install',
    TRY: 'try',
    LAUNCH_SERVICE: 'launchService',
    GET_LINK: 'getLink',
    SEE_MORE: 'seeMore',
    ERROR_INFO: 'errorInfo',
    NOT_COMPATIBLE: 'not-compatible',
    PROGRESS_CANCEL: 'progressCancel',
    CANCEL: 'cancel',
    DONE: 'done',
    APP_TILE_CLICK: 'appTileClick',
    UPDATE_STATUS: 'update-status',
};

const STATUS_SORT_ORDER_MAP = new Map();
const PROGRESS_UPDATE_CTA_ID = 'updateInProgress';

STATUS_SORT_ORDER_MAP.set(ACTION_ID.UPDATE, 0);
STATUS_SORT_ORDER_MAP.set(ACTION_ID.OPEN, 1);
STATUS_SORT_ORDER_MAP.set(ACTION_ID.START_TRIAL, 2);
STATUS_SORT_ORDER_MAP.set(ACTION_ID.BUY_NOW, 3);
STATUS_SORT_ORDER_MAP.set(PROGRESS_UPDATE_CTA_ID, 0);


const SUPPORTED_OS = {
    APPLE: 'apple',
    ANDROID: 'android',
    WINDOWS: 'windows',
};


export {
    APP_PLATFORM,
    ACTION_VARIANT_TYPE,
    LABEL_VARIANT_TYPE,
    ICON_VARIANT_TYPE,
    PLATFORM_FILTERS,
    DESKTOP_APP_FILTERS,
    UPDATES_APP_FILTERS,
    ACTION_ID,
    SUPPORTED_OS,
    ACTION_BAR_SECTION,
    STATUS_SORT_ORDER_MAP,
    PROGRESS_UPDATE_CTA_ID,
};
